import { generateUtilityClass, generateUtilityClasses } from '@ori-ui/mui-bundle/base';
export function getToggleUtilityClass(slot) {
  return generateUtilityClass('MuiOriToggle', slot);
}
export const switchClasses = generateUtilityClasses('MuiOriToggle', ['root', 'fullWidth', 'text', 'textActive', 'indicator', 'disabled', 'indicatorActive', 'checkbox', 'icon']);
export default switchClasses;
//# sourceMappingURL=toggleClasses.js.map